import React from 'react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Marcos T.',
    city: 'Buenos Aires',
    text: 'Doy clases hace 4 años y siempre perdía horas armando circuitos. Este kit me salvó. Los alumnos notan la diferencia.',
    role: 'Profe de funcional'
  }, {
    name: 'Lucía G.',
    city: 'Córdoba',
    text: 'El tomo de clases avanzadas es increíble. Mis alumnos transpiran en serio y se divierten con los AMRAPs.',
    role: 'Coach en gimnasio'
  }, {
    name: 'Federico R.',
    city: 'Rosario',
    text: 'Los juegos funcionales me ayudaron a retener alumnos aburridos de la rutina. Todo estructurado, mucha paz mental.',
    role: 'Entrenador personal'
  }, {
    name: 'Ana M.',
    city: 'Mendoza',
    text: 'La planificación semanal es oro puro. Entro al box sabiendo exactamente qué toca hoy.',
    role: 'Profe independiente'
  }, {
    name: 'Gastón P.',
    city: 'La Plata',
    text: 'El banco de ejercicios está muy bien clasificado. Antes perdía tiempo pensando variantes, ahora tengo todo a mano.',
    role: 'Dueño de centro'
  }];
  return <section className="bg-[#F5F5F5] py-3 md:py-4 px-3 border-b border-gray-200" data-id="element-164">
      <div className="max-w-4xl mx-auto" data-id="element-165">
        <h2 className="text-xl md:text-2xl font-black text-[#0B1F3A] text-center mb-3 uppercase tracking-tight" data-id="element-166">
          Testimonios de profesores
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-1.5" data-id="element-167">
          {testimonials.map((t, i) => <div key={i} className="bg-white border border-gray-200 p-2.5 rounded-lg flex flex-col shadow-sm" data-id="element-168">
              <div className="text-[#FF6B00] text-xs mb-1 tracking-widest" data-id="element-169">
                ★★★★★
              </div>
              <p className="text-gray-700 font-bold text-xs mb-2 flex-grow italic" data-id="element-170">
                "{t.text}"
              </p>
              <div className="border-t border-gray-100 pt-1.5" data-id="element-171">
                <p className="font-black text-[#0B1F3A] text-xs uppercase" data-id="element-172">
                  {t.name}
                </p>
                <p className="text-[10px] font-bold text-gray-500 uppercase" data-id="element-173">
                  {t.role} • {t.city}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}